import { render, staticRenderFns } from "./sp-feature-feature.vue?vue&type=template&id=06efb6c0&scoped=true"
import script from "./sp-feature-feature.vue?vue&type=script&lang=js"
export * from "./sp-feature-feature.vue?vue&type=script&lang=js"
import style0 from "./sp-feature-feature.vue?vue&type=style&index=0&id=06efb6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06efb6c0",
  null
  
)

export default component.exports